import { NoddiIcon, type NoddiIconName } from 'noddi-ui-common';
import type { ReactNode } from 'react';

/** The one section label for every sheet in this feature — headings must not drift between them. */
export const SectionHeading = ({ icon, children }: { icon: NoddiIconName; children: ReactNode }) => (
  <h3 className='flex items-center gap-2 font-semibold'>
    <NoddiIcon name={icon} size='small' className='shrink-0 text-muted-foreground' />
    <span className='min-w-0 truncate'>{children}</span>
  </h3>
);
